module.exports = __webpack_public_path__ + "resources/video-call-0e4e774d16568b160d5ea3bd8212992a.svg";